/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import EnableAccountMultiForm from './EnableAccountMultiForm/EnableAccountMultiForm';
import EnableAccountMultiSuccess from './EnableAccountMultiSuccess/EnableAccountMultiSuccess';
import EnableAccountMultiError from './EnableAccountMultiError/EnableAccountMultiError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class EnableAccountMulti extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const fields: Array<Object> = [
      {
        name: 'enableAccountForm',
        label: t('general:actions.enable_account_plural'),
        title: 'Enable Accounts',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const accountIds = currentAccountDetails.map(account => account.id);

        const { reason } = data.values().enableAccountForm;

        actionDrawerStore.enableDisableAccountMulti({
          is_enabled: true,
          activity_reason: reason,
          account_ids: accountIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'enableAccountMulti',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.enable_account_plural')} />
          <EnableAccountMultiError
            currentAccountDetails={currentAccountDetails}
            response={actionDrawerStore.response}
          />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.enabled}`}>
          <ActionDrawerHeader title={t('general:actions.enable_account_plural')} />
          <EnableAccountMultiSuccess
            currentAccountDetails={currentAccountDetails}
            response={actionDrawerStore.response}
          />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.enable_account_plural')} />
        <EnableAccountMultiForm
          currentAccountDetails={currentAccountDetails}
          form={this.createForm()}
        />
      </div>
    );
  }
}
